/**
 * How often the read-only surfaces re-ask while work is in flight.
 *
 * One module so the cadences are comparable and cannot drift apart per-feature:
 * they were previously inline literals repeated across several query
 * definitions, with two views of the same TOV cascade polling at different
 * rates.
 */

/** A crawl run in progress. */
export const RUN_POLL_MS = 3000;

/** The run list once nothing is running: slow background freshness. */
export const RUN_IDLE_POLL_MS = 15000;

/** A TOV source moving through parse -> chunk -> embed -> map. */
export const SOURCE_POLL_MS = 2000;

/**
 * The per-source detail fan-out (page and chunk counts), which issues two
 * requests per source and so asks less often than the source list itself.
 */
export const SOURCE_DETAIL_POLL_MS = 5000;

/** A TOV mapping attempt while its worker run is in flight. */
export const MAP_ATTEMPT_POLL_MS = 3000;
